<template>
    <div class="back-to-top" :class="{ 'back-to-top-active': active }">
        <button @click.stop.prevent="scrollUp">Back to Top</button>
    </div>
</template>

<script>
import throttle from 'lodash/throttle';

export default {
    data() {
        return {
            active: false,
        };
    },
    mounted() {
        this.watchFunc = throttle(this.watchScroll, 500);

        window.addEventListener('scroll', this.watchFunc);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.watchFunc);
    },
    methods: {
        watchScroll() {
            this.active = window.scrollY > 2000;
        },
        scrollUp() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        },
    },
};
</script>

